import { useState } from "react";
import { useTownSession } from "../app/TownSessionContext";
import { useTownStore } from "../state/store";
import { Dialog } from "./Dialog";

/** One controllable avatar per actor (docs/03 section 1): the older tab is told and may take control back. */
export function ControlTakenDialog() {
  const session = useTownSession();
  const problem = useTownStore((s) => s.roomProblem);
  const setRoomProblem = useTownStore((s) => s.setRoomProblem);
  const [busy, setBusy] = useState(false);
  if (!problem || problem.state !== "control_taken") return null;
  return (
    <Dialog title={problem.title} onClose={() => setRoomProblem(null)} closeLabel="Close — this tab stays disconnected">
      <p>{problem.message}</p>
      <p className="muted small">This tab is disconnected from the town. Take control here to use your avatar from this tab (the other tab will lose it), or close this notice.</p>
      <div className="row">
        <button
          type="button"
          className="btn btn-primary"
          data-autofocus
          disabled={busy || !session}
          onClick={async () => {
            setBusy(true);
            await session?.takeControlHere();
            setBusy(false);
          }}
        >
          {busy ? "Taking control…" : "Take control here"}
        </button>
        <button type="button" className="btn" onClick={() => setRoomProblem(null)}>
          Close
        </button>
      </div>
    </Dialog>
  );
}
